import '../../App.css';
import React, {Component, Container} from 'react';
import {Row,Col,Image,Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Card from './card';
import NavBarTop from "./navbar";
import Footer from "./footer";


class IcmtCnContact extends Component {
  constructor(props){
    super(props);
    this.state = {
       
    };

    this.setval = this.setval.bind(this)
  }

  setval(obj){
    this.setState(obj)
  }
  componentDidMount(){
    this.props.setval({comp:"icmt-cn"}) 
  }      
      
  render(){
    return (
      <div style={{backgroundImage:"url('/assets/contact-banner.jpg')",backgroundRepeat:"no-repeat",backgroundSize:"100vw 100vh",
        maxHeight:"100vh",overflow:"hidden",filter:"brightness(90%)",backgroundBlendMode:"luminosity"}}>
        {/* <img src="../assets/contact-banner.jpg" alt="" width="100%" style={{borderRadius:"0px"}} /> */}

      <div className="home-content-div" style={{textAlign:"justify",textJustify:"inter-word", padding:"4% 6%",fontFamily:"Courgette"}}>
        
        <h2 style={{fontWeight:"bold",fontSize:"2.6rem",}}>{"联系我们"}</h2>

        <div style={{display:"flex"}}>
            <div style={{margin:"30px 4%",fontSize:"2.2rem",fontWeight:"bold"}}>
                {"如有任何疑问，请联系我们，我们会尽快回复您。"}
            </div>
        </div>

        <div style={{display:"flex"}}>
            <div style={{marginLeft:"2%"}}>
                <img src="../assets/contact-mail.png" alt="Email " width={"55px"} height={"55px"}/>
            </div>
            <div style={{marginLeft:"4%",marginTop:"14px",fontWeight:"bold",fontSize:"1.3rem"}}>
              <a href="mailto:icmtcompetition@gmail.com?subject=比賽查询&amp;body=致国际古典音乐才艺大赛主办方:">
                    icmtcompetition@gmail.com
                    </a>
                
            </div>
           
        </div>

        {/* <div style={{display:"flex"}}>
            <div style={{marginLeft:"2%"}}>
                <img src="../assets/contact-whatsapp.jpg" alt="WhatsApp " width={"55px"} height={"55px"}/>
            </div>
            <div style={{marginLeft:"4%",marginTop:"14px"}}>
                <h5>(852) 8491 8253 </h5>
            </div>
           
        </div> */}

           
        
      </div>
      </div>
    );
  }
  }
  

export default IcmtCnContact;
